import { FDMap } from '../../../util/data-structure/FDMap';
import { IKPIRequestDataModel } from '../../../data-models/kpi-requests.data-model';
import { fetchAssignedKPIRequests } from '../../queries/KPIRequestsQueries';

export async function getAssignedKPIs() {
  const allRequests = await fetchAssignedKPIRequests();

  return allRequests
    .sort((requestA, requestB) => {
      const d1 = new Date(requestA.sentAt!);
      const d2 = new Date(requestB.sentAt!);

      return d2.getTime() - d1.getTime();
    })
    .reduce((byCompany, request) => {
      return byCompany.setOrUpdate(request.companyId, [request], (value) => {
        value.push(request);
        return value;
      });
    }, new FDMap<number, IKPIRequestDataModel[]>());
}
